import type { BaseSelection } from '@blocksuite/affine/store';
import { ColorLogger } from '@affine/debug/color';

const logger = new ColorLogger('selection-parse');

// 用于判断当前鼠标选中的内容是否为空
export function judgeSelectionIsEmpty(selections: BaseSelection[]): boolean {
  logger.log(
    'judgeSelectionIsEmpty: received selections',
    { count: selections?.length || 0 },
    selections
  );

  if (!selections || selections.length === 0) {
    logger.log('judgeSelectionIsEmpty: no selections');
    return true;
  }

  // 有多个选择项，肯定不为空
  if (selections.length >= 2) {
    logger.log('judgeSelectionIsEmpty: multiple selections, not empty');
    return false;
  }

  const selection = selections[0];
  const type = selection.type;

  logger.log('judgeSelectionIsEmpty: selection type', { type }, selection);

  // 暂时不处理 TableSelection
  if (type === 'table') {
    logger.log('judgeSelectionIsEmpty: table selection, not empty');
    return false;
  }

  // 处理块选择（block selection）
  if (type === 'block') {
    logger.log('judgeSelectionIsEmpty: block selection, not empty');
    return false;
  }

  // 处理图片选择（image selection）
  if (type === 'image') {
    logger.log('judgeSelectionIsEmpty: image selection, not empty');
    return false;
  }

  // 处理文本选择（text selection）
  if (type === 'text') {
    const textSelection = selection as any;
    // 检查是否有选中的文本长度
    if (textSelection.from && textSelection.to) {
      const hasTextSelection =
        textSelection.from.length > 0 ||
        textSelection.to.blockId !== textSelection.from.blockId ||
        textSelection.to.index !== textSelection.from.index;
      logger.log(
        'judgeSelectionIsEmpty: text selection hasTextSelection',
        { hasTextSelection }
      );
      if (hasTextSelection) {
        return false;
      }
    }

    // 作为备选，检查浏览器原生选择
    const browserSelection = window.getSelection();
    if (browserSelection && browserSelection.toString().length > 0) {
      logger.log('judgeSelectionIsEmpty: browser selection has content');
      return false;
    }
  }

  logger.log('judgeSelectionIsEmpty: selection is empty');
  return true;
}
